



















import { Component, Vue } from 'vue-property-decorator';
import SideNav from './Common/SideNav/SideNav.vue';
import TopNav from './Common/TopNav/TopNav.vue';
import ScrollTop from './Common/ScrollTop.vue';
import MainContent from './Common/MainContent.vue';
import DeployDialog from './Deployments/DeployDialog.vue';

@Component({
  name: 'app-main',
  components: {
    SideNav,
    ScrollTop,
    TopNav,
    MainContent,
    DeployDialog
  }
})
export default class AppMain extends Vue {}
